"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionCardContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var _Typography = _interopRequireDefault(require("../../../../components/PageGrid/molecules/Typography/Typography"));

var _ActionCard = _interopRequireDefault(require("./components/ActionCard/ActionCard"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ActionCardContainer = function ActionCardContainer(_ref) {
  var rootClass = _ref.rootClass,
      menuName = _ref.menuName,
      actionCards = _ref.actionCards,
      height = _ref.height,
      width = _ref.width,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorRef = (0, _react.useRef)(null);
  var defaultStyling = {
    padding: '20px 10%',
    marginTop: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    outline: 'none'
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, _objectSpread({}, defaultStyling));

  var handleToggle = function handleToggle() {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };

  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    ref: anchorRef,
    "aria-controls": open ? 'menu-list-grow' : undefined,
    "aria-haspopup": "true",
    onClick: handleToggle,
    "data-testid": "menuButton"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, menuName[0])), /*#__PURE__*/_react.default.createElement(_core.Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/_react.default.createElement(_core.Grow, (0, _extends2.default)({}, TransitionProps, {
      style: {
        transformOrigin: 'center top'
      }
    }), /*#__PURE__*/_react.default.createElement(_core.Paper, {
      style: {
        minWidth: '100vw',
        height: '100%'
      },
      id: "paper-test"
    }, /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/_react.default.createElement(_core.MenuList, {
      autoFocusItem: open,
      id: "menu-list-grow",
      className: styles.root
    }, actionCards.map(function (card, index) {
      return /*#__PURE__*/_react.default.createElement(_ActionCard.default, (0, _extends2.default)({}, card, {
        key: index,
        height: height,
        width: width
      }));
    })))));
  }));
};

exports.ActionCardContainer = ActionCardContainer;
var _default = ActionCardContainer;
exports.default = _default;
ActionCardContainer.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Override or extend the styles applied to the component
  * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Height of the each Action Card.
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Width of the each Action Card.
   */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Text Displayed for menu
   * Component: Typography
   */
  menuName: function menuName(props, propName, componentName) {
    return (0, _customProps.validComponents)(props, propName, componentName, ['Typography']);
  },

  /**
   * Cards passed ot ActionCardContainer to render
   * Component: ActionCard
   */
  actionCards: function actionCards(props, propName, componentName) {
    return (0, _customProps.validComponents)(props, propName, componentName, ['ActionCard']);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
ActionCardContainer.defaultProps = {
  rootClass: [],
  height: '100px',
  width: '200px',
  menuName: [],
  actionCards: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};